import { useMemo, useState } from "react";
import Accordion from "../../../../components/Accordion";
import holidayroom from '../../../../assets/img/hotel/icon-holiday-room.svg'

const HotelsReviewcomponents = ({ details, rateConditions }) => {
    const [showMoreAmenities, setShowMoreAmenities] = useState(8);

    const sortedItems = useMemo(() => {
        let countMap = {};
        details?.[0]?.name?.forEach((item) => {
            countMap[item] = (countMap[item] || 0) + 1;
        });
        const uniqueValues = Object?.keys(countMap);
        const repetitions = Object?.values(countMap);
        return { uniqueValues, repetitions }
    }, [details]);


    // Utility to decode HTML entities twice
    const decodeHTML = (html) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.value;
    };

    return (
        <>
            <div className="features">
                <Accordion
                    title="Room Details"
                    icon={holidayroom}
                >
                    <div className="detailDiv room-detail-list">
                        {sortedItems?.uniqueValues?.length > 1 ?
                            sortedItems?.uniqueValues?.map((el, index) => (
                                <h5 key={index}>{sortedItems?.repetitions?.[index]}&nbsp;x&nbsp;{el}</h5>
                            ))
                            : <h5>{sortedItems?.repetitions?.[0]}&nbsp;x&nbsp;{sortedItems?.uniqueValues?.[0]}</h5>
                        }
                        {
                            details?.[0]?.roomPromotion &&
                            <div className="mb-3">
                                <h6>Room Promotion</h6>
                                <ul>
                                    <li> {details?.[0]?.roomPromotion?.[0]} </li>
                                </ul>
                            </div>
                        }
                        {
                            details?.[0]?.amenities &&
                            <div className="mb-3">
                                <h6>Amenities</h6>
                                <ul className='px-1'>
                                    <div className="row px-2">
                                        {[...new Set(details?.[0]?.amenities)]?.slice(0, showMoreAmenities)?.map((el, index) => (
                                            <li key={index} className='col-md-4 col-12' >{el}</li>
                                        ))}
                                        {showMoreAmenities < [...new Set(details?.[0]?.amenities)]?.length
                                            ?
                                            <span onClick={() => setShowMoreAmenities([...new Set(details?.[0]?.amenities)]?.length)} className='col-md-4 col-12 text-primary cursor_pointer' >
                                                View More
                                            </span>
                                            : showMoreAmenities <= [...new Set(details?.[0]?.amenities)]?.length && <span onClick={() => setShowMoreAmenities(8)} className='col-4 text-primary cursor_pointer' >View Less</span>}
                                    </div>
                                </ul>
                            </div>
                        }
                        {
                            details?.[0]?.inclusion &&
                            <div className="mb-3">
                                <h6>Inclusion</h6>
                                <ul className='px-1'>
                                    <div className="row px-2">
                                        {
                                            details?.[0]?.inclusion?.split(",")?.map((inc, incIndex) => (
                                                <li key={`inc${incIndex}`} className='col-md-4 col-12' > {inc} </li>

                                            ))
                                        }
                                    </div>
                                </ul>
                            </div>
                        }
                        {
                            details?.[0]?.supplements?.[0]?.length > 0 &&
                            <div className="mb-3">
                                <h6>Supplements</h6>
                                <ul>
                                    {
                                        details?.[0]?.supplements?.[0]?.map((supp, suppIndex) =>
                                            (<li key={`supp${suppIndex}`} > {supp?.type} {supp?.price} {supp?.currency} ({supp?.description}) </li>)
                                        )
                                    }
                                </ul>
                            </div>
                        }
                        {
                            details?.[0]?.cancelPolicies?.length > 0 &&
                            <div className="mb-3">
                                <h6>Cancellation Policy</h6>
                                <ul>
                                    {
                                        details?.[0]?.cancelPolicies?.map((cp, cpIndex) => (
                                            <li key={`cp${cpIndex}`} >
                                                From date: {cp?.fromDate} &nbsp;
                                                Cancellation charge: {cp?.chargeType?.toLowerCase() === "percentage" ? `${cp?.cancellationCharge} %` : `₹ ${cp?.cancellationCharge}`}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </Accordion>
            </div>

            {/* #region Property Rules Start */}
            <div className="features">
                <Accordion
                    title="Room Rules"
                    icon={holidayroom}
                >
                    <div className="detailDiv room-detail-list">
                        <ul>
                            {rateConditions.map((item, index) => {
                                const decodedOnce = decodeHTML(item);
                                const decodedTwice = decodeHTML(decodedOnce);
                                const isHTML = /<ul|<li|<p|<a|<br/.test(decodedTwice);

                                return (
                                    <li key={index} style={{ marginBottom: '10px' }}>
                                        {isHTML ? (
                                            <div dangerouslySetInnerHTML={{ __html: decodedTwice }} />
                                        ) : (
                                            decodedTwice
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </Accordion>
            </div>

        </>
    )
}

export default HotelsReviewcomponents